import { cn } from "@tine/designsystem-utils";
import { chunk } from "lodash-es";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import Button from "./Button";

type ExpandableListProps = {
   items: React.ReactElement[];
   cutoff?: number;
};

const ExpandableList = ({ items, cutoff = 3 }: ExpandableListProps) => {
   const [lastVisibleListIndex, setLastVisibleListIndex] = useState(0);
   const chunkList = chunk(items, cutoff);
   const chunkStyle = "transition-[max-height] duration-500 overflow-hidden";
   return (
      <div>
         {chunkList.map((list, index) => {
            const heightStyle = index <= lastVisibleListIndex ? "max-h-[250px]" : "max-h-0";
            return (
               <div key={`favoritelists-list-${index + 1}`}>
                  <div className={cn(chunkStyle, heightStyle)}>
                     <div id={`visible-list-${index}`} className="flex flex-col">
                        {index <= lastVisibleListIndex && list.map((element) => element)}
                     </div>
                  </div>
                  {index - 1 === lastVisibleListIndex && (
                     <Button
                        variant="tertiary"
                        className="my-2 size-fit"
                        onClick={() => setLastVisibleListIndex(lastVisibleListIndex + 1)}
                        aria-controls={`visible-list-${index}`}
                     >
                        Vis flere
                     </Button>
                  )}
               </div>
            );
         })}
      </div>
   );
};

export default observer(ExpandableList);
